/* LOG TYPES */
export enum CLICK_LOG_TYPES {
    MEDIA_SEARCH = 'media_search_v2',
    AUDIO_SEARCH = 'audio_search_v1',
    RECENT_SEARCH = 'recent_search_v1',
    FAVORITE_SEARCH = 'favorite_search_v1',
    UPLOADS_SEARCH = 'uploads_search_v1',
    MEDIA_RECOMMENDATIONS = 'media_recommendations_v1',
    AUDIO_RECOMMENDATIONS = 'audio_recommendations_v1',
    RECENT_RECOMMENDATIONS = 'recent_recommendations_v1',
    FAVORITE_RECOMMENDATIONS = 'favorite_recommendations_v1',
    UPLOADS_RECOMMENDATIONS = 'uploads_recommendations_v1',
    TENOR_STICKERS_SEARCH = 'tenor_stickers_search_v1',
}

export enum SITE_SEARCH_TYPES {
    MEDIA_SEARCH = 'media',
    AUDIO_SEARCH = 'audio',
    RECENT_SEARCH = 'recent',
    FAVORITE_SEARCH = 'favorite',
    UPLOADS_SEARCH = 'uploads',
    MEDIA_RECOMMENDATIONS = 'media_recommendations',
    AUDIO_RECOMMENDATIONS = 'audio_recommendations',
    RECENT_RECOMMENDATIONS = 'recent_recommendations',
    FAVORITE_RECOMMENDATIONS = 'favorite_recommendations',
    UPLOADS_RECOMMENDATIONS = 'uploads_recommendations',
}
